import {
	createResource,
	type CreateResourceArgBase,
	type ResourceStoreContext,
	type RouterDataContext,
} from 'react-resource-router';

import { type PaginationRouteResource, type ResourceResponse } from '../../../common/types';

import { type PaginationParams } from './types';

type CreatePaginatedResourceArg<T> = CreateResourceArgBase & {
	getData: (
		routerContext: RouterDataContext,
		customContext: ResourceStoreContext,
	) => (params: PaginationParams) => ResourceResponse<T> | Promise<ResourceResponse<T>>;
};

export const createPaginatedResource = <T>({
	getData,
	getKey,
	...arg
}: CreatePaginatedResourceArg<T>): PaginationRouteResource<T> => {
	return createResource({
		...arg,
		getKey: (routerContext, customContext) => {
			const { query } = routerContext;
			const page = query['page'] || '1';
			const key: string = `${getKey(routerContext, customContext)}#${page}`;
			return key;
		},
		getData: (routerContext, customContext) => {
			const { query } = routerContext;
			const page = parseInt(query['page']) || 1;
			return getData(routerContext, customContext)({ page });
		},
	});
};
